module.exports = __webpack_public_path__ + "img/p3_6.05d699fe.png";